/**
 * What members call the view of their taste groups (CONTEXT.md, Taste group): the Taste page's groups section, the TV's
 * Taste screen, and the Home lines that lead there. A change of name changes this file alone.
 */
export const TASTE_GROUPS_NAME = {
	/** The view's name in a sentence or a heading. */
	title: "Your taste mix",
} as const
